/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const dynamicDiscountBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.dynamic_discount_events),
  getBaseQueryKey(Query_Keys.dynamic_discount_events_matrix)
);

export const dynamicDiscountMutationKeyGroups = {
  create: dynamicDiscountBaseKeys,
  update: dynamicDiscountBaseKeys,
  delete: dynamicDiscountBaseKeys,
};
